export default {
  'lv2':[{
    'title':'_an',
    'choose':['b','d','c','f'],
    'answer':'c'
  },{
    'title':'th_',
    'choose':['a','o','e','s'],
    'answer':'e'
  },{
    'title':'_aid',
    'choose':['c','t','v','s'],
    'answer':'s'
  },{
    'title':'g_',
    'choose':['a','e','o','u'],
    'answer':'o'
  },{
    'title':'_ome',
    'choose':['c','k','d','s'],
    'answer':'c'
  },{
    'title':'_or',
    'choose':['t','f','m','h'],
    'answer':'f'
  },{
    'title':'_wo',
    'choose':['l','b','t','s'],
    'answer':'t'
  },{
    'title':'_p',
    'choose':['a','o','u','d'],
    'answer':'u'
  },{
    'title':'n_t',
    'choose':['a','u','o','e'],
    'answer':'o'
  },{
    'title':'_ne',
    'choose':['o','u','a','w'],
    'answer':'o'
  },{
    'title':'_nd',
    'choose':['a','e','o','u'],
    'answer':'a'
  },{
    'title':'_o',
    'choose':['t','s','d','f'],
    'answer':'t'
  },],

  'lv3':[{
    'title':'a_',
    'choose':['d','b','t','f'],
    'answer':'t'
  },{
    'title':'_aw',
    'choose':['c','z','v','s'],
    'answer':'s'
  },{
    'title':'th__',
    'choose':['as','os','is','iz'],
    'answer':'is'
  },{
    'title':'g__d',
    'choose':['au','ou','oo','ew'],
    'answer':'oo'
  },{
    'title':'_ame',
    'choose':['c','k','cd','s'],
    'answer':'c'
  },{
    'title':'_our',
    'choose':['t','f','m','h'],
    'answer':'f'
  },{
    'title':'_oo',
    'choose':['l','b','t','s'],
    'answer':'t'
  },{
    'title':'__der',
    'choose':['au','ou','un','on'],
    'answer':'un'
  },{
    'title':'n__',
    'choose':['au','ou','ow','ew'],
    'answer':'ow'
  },{
    'title':'_n',
    'choose':['o','u','a','e'],
    'answer':'oc'
  },{
    'title':'w__t',
    'choose':['an','en','on','un'],
    'answer':'an'
  },{
    'title':'__o',
    'choose':['wh','sh','ch','h'],
    'answer':'wh'
  },],

  'lv4':[{
    'title':'a__',
    'choose':['le','el','ll','re'],
    'answer':'ll'
  },{
    'title':'ha__',
    'choose':['vi','vy','we','ve'],
    'answer':'ve'
  },{
    'title':'th__',
    'choose':['at','ot','it','ut'],
    'answer':'at'
  },{
    'title':'aft__',
    'choose':['ar','or','er','ur'],
    'answer':'er'
  },{
    'title':'__om',
    'choose':['fr','fl','fu','fi'],
    'answer':'fr'
  },{
    'title':'st__',
    'choose':['ot','op','ob','up'],
    'answer':'op'
  },{
    'title':'op__',
    'choose':['an','on','en','un'],
    'answer':'en'
  },{
    'title':'h__',
    'choose':['ar','ur','er','or'],
    'answer':'er'
  },{
    'title':'h__',
    'choose':['az','os','as','us'],
    'answer':'as'
  },{
    'title':'h__',
    'choose':['ow','uw','au','ew'],
    'answer':'ow'
  },{
    'title':'we__',
    'choose':['re','er','ar','ra'],
    'answer':'re'
  },{
    'title':'__ke',
    'choose':['ta','te','da','tu'],
    'answer':'ta'
  },],

  'lv5':[{
    'title':'ca__',
    'choose':['le','el','ll','ar'],
    'answer':'ll'
  },{
    'title':'__ld',
    'choose':['cu','ku','ko','co'],
    'answer':'co'
  },{
    'title':'do__',
    'choose':['as','os','es','ez'],
    'answer':'es'
  },{
    'title':'fa__',
    'choose':['sd','zt','st','zd'],
    'answer':'st'
  },{
    'title':'fi__',
    'choose':['ve','vi','vy','we'],
    'answer':'ve'
  },{
    'title':'__ve',
    'choose':['gi','ga','ka','ki'],
    'answer':'ga'
  },{
    'title':'go__',
    'choose':['us','ez','es','as'],
    'answer':'es'
  },{
    'title':'i__',
    'choose':['tz','ty','ts','ds'],
    'answer':'ts'
  },{
    'title':'ma__',
    'choose':['d','di','de','dy'],
    'answer':'de'
  },{
    'title':'o__',
    'choose':['ff','f','ve','v'],
    'answer':'ff'
  },{
    'title':'ve__',
    'choose':['ry','ly','ri','li'],
    'answer':'ry'
  },{
    'title':'r__d',
    'choose':['ea','ee','ae','i'],
    'answer':'ea'
  },],

  'lv6':[{
    'title':'ar__nd',
    'choose':['au','eu','ou','on'],
    'answer':'ou'
  },{
    'title':'__ly',
    'choose':['un','an','en','on'],
    'answer':'on'
  },{
    'title':'tod__',
    'choose':['ay','oy','ai','ey'],
    'answer':'ey'
  },{
    'title':'fa__',
    'choose':['le','el','ll','l'],
    'answer':'ll'
  },{
    'title':'fou__',
    'choose':['nd','md','nt','d'],
    'answer':'nd'
  },{
    'title':'k__p',
    'choose':['ae','ee','ea','ei'],
    'answer':'ee'
  },{
    'title':'h__',
    'choose':['at','ut','ot','od'],
    'answer':'ot'
  },{
    'title':'wh__',
    'choose':['en','an','un','em'],
    'answer':'en'
  },{
    'title':'the__',
    'choose':['ar','er','ir','ur'],
    'answer':'ir'
  },{
    'title':'o__',
    'choose':['ff','f','ve','v'],
    'answer':'ff'
  },{
    'title':'she__',
    'choose':['ow','ew','uw','aw'],
    'answer':'ow'
  },{
    'title':'nev__',
    'choose':['er','ar','or','ur'],
    'answer':'er'
  },],
}



// WEBPACK FOOTER //
// ./src/testdata/sight.js